interface ProductQuantityProps {
    quantity: number
}

export const ProductQuantity = ({ quantity }: ProductQuantityProps) => {
    return (
        <p className='text-xs lg:text-base'>
            Encontramos{' '}
            <span className='text-red-wine font-bold'>
                {quantity} produtos
            </span>
        </p>
    )
}
